import { createSlice } from '@reduxjs/toolkit';
import { fileUploadItem, updateImageByUrl, upload } from '../thunk/uploadThunk';

const initialState = {
  loading: false,
  error: null,
  upload_url: null,
  fileUploadLoading: false,
  fileUploadRes: null,
};

export const UploadSlice = createSlice({
  name: 'upload',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(upload.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(upload.fulfilled, (state, action) => {
        state.loading = false;
        state.upload_url = action.payload ?? null;
      })
      .addCase(upload.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateImageByUrl.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateImageByUrl.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateImageByUrl.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fileUploadItem.pending, (state) => {
        state.fileUploadLoading = true;
        state.error = null;
      })
      .addCase(fileUploadItem.fulfilled, (state, action) => {
        state.fileUploadLoading = false;
        state.fileUploadRes = action.payload;
      })
      .addCase(fileUploadItem.rejected, (state, action) => {
        state.fileUploadLoading = false;
        state.fileUploadRes = null;
        state.error = action.payload;
      });
  },
});

export default UploadSlice.reducer;
